import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'dark' | 'light';

interface ThemeStore {
  theme: Theme;
  setTheme: (next: Theme) => void;
  toggleTheme: () => void;
}

const applyToDom = (t: Theme) => {
  const root = document.documentElement;
  root.classList.toggle('dark', t === 'dark');
  root.classList.toggle('light', t === 'light');
};

export const useTheme = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      setTheme: (next) => {
        // Use the View Transitions API for the cross-fade morph (May 2026 production).
        const setIt = () => {
          set({ theme: next });
          applyToDom(next);
        };
        const startVT = (document as Document & {
          startViewTransition?: (cb: () => void) => unknown;
        }).startViewTransition;
        if (typeof startVT === 'function') startVT.call(document, setIt);
        else setIt();
      },
      toggleTheme: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
    }),
    {
      name: 'foctta-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyToDom(state.theme);
        else applyToDom('dark');
      },
    },
  ),
);
